var i,e;!function(i){i.Frac="FR",i.Wireline="WL"}(i||(i={})),function(i){i.active="active",i.idle="idle"}(e||(e={}));export{e as AssetStatus,i as StreamType};
